<template>
    <div id="app">
        <router-view name="blank"></router-view>
        <router-view :key="key"></router-view>
    </div>
</template>

<script>
	export default {
		name: 'app',
		computed: {
			key() {
				return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
			}
		}
	}
</script>

<style lang="scss">
    #app {
        background-color: #222d32;
        .el-table{
            tr{
                /*height: 30px;*/
                td{
                    padding: 6px;
                }
            }
        }
    }
</style>